import React, {ComponentType} from 'react';

import {registerModelWatcherEnhancer} from 'app/subscriptions';

import type {ModelSubscribedComponentPropsType} from 'app/subscriptions/types';

export type {ModelSubscribedComponentPropsType};

export function keepUpdatedEnhancer<P>(
  WrappedComponent: ComponentType<P & ModelSubscribedComponentPropsType>
) {
  return window.WebSocket
    ? registerModelWatcherEnhancer<P>(WrappedComponent)
    : noopRefetchEnhancer<P>(WrappedComponent);
}

function noopRefetchEnhancer<P>(
  WrappedComponent: ComponentType<P & ModelSubscribedComponentPropsType>
): ComponentType<P> {
  return function NoopRefetchComponent(props: P) {
    return <WrappedComponent onModelChange={() => undefined} {...props} />;
  };
}
